<template>
  <transition name="fade">
    <div class="modal-email-preview">
      <div class="lv3-title-text">Email Preview</div>
      <div class="email-preview-container" v-if="poEmail">
        <div class="email-preview-wrapper">
          <div class="column20 mr10">Nomor PO</div>
          <div class="column5 mr10">:</div>
          <div class="column20 mr10">{{ poEmail.PO_NUMBER }}</div>
        </div>
        <div class="email-preview-wrapper">
          <div class="column20 mr10">Tanggal PO</div>
          <div class="column5 mr10">:</div>
          <div class="column20 mr10">{{ formatDate(poEmail.PO_DATE) }}</div>
        </div>
        <div class="email-preview-wrapper">
          <div class="column20 mr10">Nilai PO</div>
          <div class="column5 mr10">:</div>
          <div class="column20 mr10">{{ curencyDelimiter(poEmail.VALUE_PER_UNIT_IDR) }}</div>
        </div>
        <div class="email-preview-wrapper">
          <div class="column20 mr10">Nilai Rata-Rata</div>
          <div class="column5 mr10">:</div>
          <div class="column20 mr10">{{ curencyDelimiter(poEmail.CSI_SCORE_AVG) }}</div>
        </div>
        <div class="email-preview-wrapper">
          <div class="column20 mr10">GR Kuantitas</div>
          <div class="column5 mr10">:</div>
          <div class="column20 mr10">{{ curencyDelimiter(poEmail.CSI_QUANTITY) }}</div>
        </div>
        <div class="email-preview-wrapper">
          <div class="column20 mr10">Keterangan</div>
          <div class="column5 mr10">:</div>
          <div class="column20 mr10">{{ csiCategory(poEmail.CSI_SCORE_AVG) }}</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      email: null,
      customText: null,
      tempText: null,
      data: {
        jabatan: 'Komisaris Utama',
        name: 'Bhakti',
        phoneNumber: '+62 8123123124',
        email: 'bhakti@graha.com'
      },
    }
  },
  computed: {
    poEmail: function () {
      return this.$store.state.modalStore.poEmail
    }
  },
  methods: {
    closeModal() {
      const self = this
      self.$store.commit('modalStore/SET_KOMISARIS_MODAL', false)
    },
    confirm() {
      this.$emit('confirmed', this.data)
    }
  }
}
</script>

<style scoped>
.email-preview-container {
  width: 100%;
  height: 80%;
}

.email-preview-wrapper {
  width: 100%;
  display: flex;
  flex-direction: row;
  font-size: 11px;
}

.epw-title {
  font-weight: bold;
  margin-bottom: 10px;
}
</style>
